import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [accessToken, setAccessToken] = useState(localStorage.getItem('token'));
    const [userId, setUserId] = useState(null);

    useEffect(() => {
        // Dummy effect to keep token in sync
        const token = localStorage.getItem('token');
        if (token !== accessToken) {
            setAccessToken(token);
        }
    }, [accessToken]);

    const login = async (data) => {
        console.log("Dummy login called");
    };

    const logout = async () => {
        console.log("Dummy logout called");
    };

    return (
        <AuthContext.Provider value={{ accessToken, setAccessToken, login, logout, userId }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
